"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Handler_1 = require("./Handler");
const text_1 = require("../../textures/text");
const Utils_1 = require("../../tree/Utils");
const Patcher_1 = require("../Patcher");
class TextHandler extends Handler_1.Handler {
    handle(obj, settings) {
        if (!obj.texture || !(obj.texture instanceof text_1.TextTexture)) {
            obj.enableTextTexture();
        }
        if (Utils_1.Utils.isString(settings)) {
            Patcher_1.Patcher.patchObjectProperty(obj.texture, "text", settings);
        }
        else {
            Patcher_1.Patcher.patchObject(obj.texture, settings);
        }
    }
}
exports.TextHandler = TextHandler;
//# sourceMappingURL=TextHandler.js.map